import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {scrollTriggerConfig, duration, scrolling} from "./animation";
import {setActiveNavItem} from "./nav";

const animateFeatures = () => {
  const sectionDuration = duration['feature'];
  const sectionEnterDelay = .15;

  // Sections
  const featureSections = [
    'feature-1',
    'feature-2',
    'feature-3',
  ];

  const imageY = 100; // vh

  function sectionVars(direction) {
    return {
      'feature-1': {
        more: {
          enter: {
            from: {x: 0, y: '25vh', autoAlpha: 0},
            to: {x: 0, y: 0, autoAlpha: 1},
          },
          leave: {
            from: {x: 0, y: 0, autoAlpha: 1},
            to: {x: 0, y: `${imageY}vh`, autoAlpha: 0},
          },
        },
      },
      'feature-2': {
        more: {
          enter: {
            from: {x: 0, y: '-10vh', autoAlpha: 0},
            to: {x: 0, y: 0, autoAlpha: 1},
          },
          leave: {
            from: {x: 0, y: 0, autoAlpha: 1},
            to: {x: 0, y: `${imageY}vh`, autoAlpha: 0},
          },
        },
      },
      'feature-3': {
        more: {
          enter: {
            from: {x: 0, y: '25vh', autoAlpha: 0},
            to: {x: 0, y: 0, autoAlpha: 1},
          },
          leave: {
            from: {x: 0, y: 0, autoAlpha: 1},
            to: {x: 0, y: '50vh', autoAlpha: 0},
          },
        },
      },
    };
  }

  featureSections.forEach((sectionId, index) => {
    const el = {
      main: `.section-${sectionId} .section-feature__main`,
      label: `.section-${sectionId} .section-feature__title-label`,
      image: `.section-${sectionId} .section-feature__media`,
      more: `.section-${sectionId} .section-feature__more`,
      more2: `.section-${sectionId} .section-feature__more2`,
    };

    const animate = (direction) => {
      return {
        enter: {
          main: {
            from: { y: '75vh', autoAlpha: 0 },
            to: { y: 0, autoAlpha: 1 },
          },
          image: {
            from: { y: `${imageY * direction}vh`, autoAlpha: 0 },
            to: { y: 0, autoAlpha: 1 },
          },
          more: sectionVars(direction)[sectionId].more.enter,
          more2: sectionVars(direction)[sectionId].more.enter,
        },
        leave: {
          main: {
            from: { x: 0, autoAlpha: 1 },
            to: { x: '-50vw', autoAlpha: 0 },
          },
          label: {
            from: { x: 0 },
            to: { x: (100 * direction) },
          },
          image: {
            from: { y: 0, autoAlpha: 1 },
            to: { y: `${imageY * direction}vh`, autoAlpha: 0 },
          },
          more: sectionVars(direction)[sectionId].more.leave,
          more2: sectionVars(direction)[sectionId].more.leave,
        },
      }
    };

    ScrollTrigger.create({
      id: sectionId,
      trigger: `.section-${sectionId}`,
      ...scrollTriggerConfig,
      onEnter: (self) => {
        setActiveNavItem();

        scrolling.disable();

        const delay = sectionId === 'feature-1' ? (duration.intro - duration.feature) : sectionEnterDelay;

        gsap.timeline({
          defaults: {
            duration: sectionDuration,
          },
        })
          .fromTo(el.main, { ...animate(1).enter.main.from }, { ...animate(1).enter.main.to }, 0)
          .fromTo(el.image, { ...animate(1).enter.image.from }, { ...animate(1).enter.image.to }, 0)
          .fromTo(el.more, { ...animate(1).enter.more.from }, { ...animate(1).enter.more.to }, 0)
          .fromTo(el.more2, { ...animate(1).enter.more2.from }, { ...animate(1).enter.more2.to }, .2)
          .delay(delay)
          .then(scrolling.enable);
      },
      onLeave: (self) => {
        scrolling.disable();
        gsap.timeline({
          defaults: {
            duration: sectionDuration,
          },
        })
          .to(el.main, { ...animate(-1).leave.main.to }, 0)
          .to(el.label, { ...animate(1).leave.label.to }, 0)
          .to(el.image, { ...animate(-1).leave.image.to }, 0)
          .to(el.more, { ...animate(-1).leave.more.to }, 0)
          .to(el.more2, { ...animate(-1).leave.more2.to }, .2)
          .then(scrolling.enable);
      },
      onEnterBack: (self) => {
        setActiveNavItem();

        scrolling.disable();

        gsap.timeline({
          defaults: {
            duration: sectionDuration,
          },
        })
          .fromTo(el.main, { ...animate(-1).leave.main.to }, { ...animate(-1).leave.main.from }, 0)
          .fromTo(el.label, { ...animate(-1).leave.label.to }, { ...animate(-1).leave.label.from }, 0)
          .fromTo(el.image, { ...animate(-1).leave.image.to }, { ...animate(-1).leave.image.from }, 0)
          .fromTo(el.more, { ...animate(-1).leave.more.to }, { ...animate(-1).leave.more.from }, 0)
          .fromTo(el.more2, { ...animate(-1).leave.more2.to }, { ...animate(-1).leave.more2.from }, .2)
          .delay(sectionEnterDelay)
          .then(scrolling.enable);
      },
      onLeaveBack: (self) => {

        scrolling.disable();

        gsap.timeline({
          defaults: {
            duration: sectionDuration,
          },
        })
          .to(el.main, { ...animate(1).enter.main.from }, 0)
          .to(el.image, { ...animate(1).enter.image.from }, 0)
          .to(el.more, { ...animate(1).enter.more.from }, 0)
          .to(el.more2, { ...animate(1).enter.more2.from }, .2)
          .then(scrolling.enable);
      },
    });

  });

}

export default animateFeatures;
